import React, { Component } from 'react';

import MyButton from '../button'

const ourStory = (props) => {
    if (props.isMobile) {
        return (
            <div data-aos="zoom-in" className="d-flex headerSection">
                <div className="col-12 p-0 h-100 d-flex justify-content-center flex-column">
                    <div className="w-100 justify-content-center d-flex">
                        <p className="m-0" style={{ fontSize: '2.5rem', fontWeight: "bold", color: "#212529" }}>Our Story  </p>
                    </div>
                    <div className="w-100 justify-content-center d-flex flex-column align-items-center" style={{ padding: "1rem 0rem" }}>
                        <p className="" style={{ fontSize: "0.98rem", textAlign: "center" }}>We are building an inclusive and diverse but closely-knit team to solve some hard technical and business problems. It doesn't hurt to have some fun along the way</p>
                        <p className="" style={{ fontSize: "0.98rem", textAlign: "center" }}>We're a hybrid company: all the advantages of a startup (culture, team size, work breadth), but without the financial and existential risks of one (we're a development team for
                            Syrasoft LLC)</p>
                    </div>
                    <div className="w-100 d-flex pt-3 justify-content-center ">
                        <MyButton value="Read More" />
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div ref={props.setOurStoryRef}  data-aos="zoom-in" className="d-flex headerSection">
                <div className="col-12 p-0 h-100 d-flex justify-content-center flex-column">
                    <p className="m-0" style={{ fontSize: '2.5rem', fontWeight: "bold", color: "#212529" }}>Our Story  </p>
                    <div style={{ padding: "3rem 0rem" }}>
                        <p className="" style={{ fontSize: "0.98rem" }}>We are building an inclusive and diverse but closely-knit team to solve some hard technical and business problems. It doesn't hurt to have some fun along the way</p>
                        <p className="" style={{ fontSize: "0.98rem" }}>We're a hybrid company: all the advantages of a startup (culture, team size, work breadth), but without the financial and existential risks of one (we're a development team for
                            Syrasoft LLC)</p>
                    </div>
                    <MyButton value="Read More" />
                </div>
            </div>
        )
    }

}

export default ourStory;